export const LOCAL_STORAGE_PREFIX = '@SyclusColetor';